import { Button, Col, Form, Input, Row } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import React from "react";
import { useTranslation } from "react-i18next";
import { ControlFailureModel } from "../../../../../models/control-failure.model";
import { FormSectionProps } from "../../../../../models/form-section.model";
import { VALIDATION_UTIL } from "../../../../../utils/validation.utils";
import { InfoCircleIcon } from "../../../../atoms/icon";
import { AppChildrenSelect, AppSelect } from "../../../../atoms/select";


const DivisionSection = (props: FormSectionProps<ControlFailureModel>) => {
    const { t } = useTranslation();

    const addField = () => {
        if (props.addField) {
            props.addField("loss_event_experiences");
        }
    }


    return (
        <div className="section-wrapper">

            <Form.List name="loss_event_experiences">
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field, index) => (
                            <Row gutter={[16, 32]} className="has-check-box" key={index}>
                                <Form.Item
                                    name={[field.name, 'id']}
                                    hidden>
                                    <Input />
                                </Form.Item>
                                <Col span={8}>
                                    <AppSelect
                                        placeholder={t("ControlFailure.plDivision")}
                                        list={props.resources?.divisions}
                                        className="lable-full-width"
                                        label={index === 0 ? t("ControlFailure.lbExperienceOfEvent") : ""}
                                        name={[field.name, 'division_id']}
                                        tooltip={{ title: t("ControlFailure.ttExperienceEvent"), icon: <InfoCircleIcon /> }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <AppChildrenSelect
                                        label={index === 0 ? " " : ""}
                                        name={[field.name, 'business_unit_id']}
                                        parentName={`loss_event_experiences[${field.name}].division_id`}
                                        list={props.resources?.business_units}
                                        placeholder={t("ControlFailure.plBU")}
                                        listFilterName="division_id"
                                    />
                                </Col>
                                <Col span={8}>

                                    <AppChildrenSelect
                                        name={[field.name, 'svp_id']}
                                        parentName={`loss_event_experiences[${field.name}].division_id`}
                                        list={props.resources?.svps}
                                        placeholder={t("ControlFailure.plSVP")}
                                        label={index === 0 ? " " : ""}
                                        listFilterName="division_id"
                                    />
                                </Col>
                            </Row>
                        ))}

                    </>

                )}
            </Form.List>

            <Form.Item
                className="mr-b-10"
                name="other_areas_experience"
                valuePropName="checked"
                rules={VALIDATION_UTIL.getRulesValidationField("other_areas_experience", props.requiredFields, undefined, " ")}>
                <Checkbox><span className="fw-medium">{t("ControlFailure.lbExperienceOfEventCheck")}</span></Checkbox>
            </Form.Item>

            <Form.Item>
                <Button className="bg-gray" type="default" shape="round" onClick={() => addField()}>
                    {t("Scenario.btnAddMore")}
                </Button>
            </Form.Item>

            <Row gutter={[16, 32]} className="has-check-box">
                <Col span={8}>
                    <AppSelect
                        placeholder={t("ControlFailure.plDivision")}
                        list={props.resources?.divisions}
                        className="lable-full-width"
                        label={t("ControlFailure.lbCauseOfEvent")}
                        name="caused_division_id"
                        tooltip={{ title: t("ControlFailure.ttCauseEvent"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("caused_division_id", props.requiredFields)}
                    />
                </Col>

                <Col span={8}>
                    <AppChildrenSelect
                        name="caused_business_unit_id"
                        parentName="caused_division_id"
                        list={props.resources?.business_units}
                        placeholder={t("ControlFailure.plBU")}
                        label="&nbsp;"
                        listFilterName="division_id"
                        rules={VALIDATION_UTIL.getRulesValidationField("caused_business_unit_id", props.requiredFields, undefined, " ")}
                    />
                </Col>
                <Col span={8}>

                    <AppChildrenSelect
                        name="caused_svp_id"
                        parentName="caused_division_id"
                        list={props.resources?.svps}
                        placeholder={t("ControlFailure.plSVP")}
                        label="&nbsp;"
                        listFilterName="division_id"
                        rules={VALIDATION_UTIL.getRulesValidationField("caused_svp_id", props.requiredFields, undefined, " ")}
                    />
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        name="other_areas_cause"
                        valuePropName="checked"
                    >
                        <Checkbox><span className="fw-medium">{t("ControlFailure.lbCauseOfEventCheck")}</span></Checkbox>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default DivisionSection;